import React, { PureComponent } from 'react';

class NonPNIGrid extends PureComponent {

  constructor(props) {
    super(props);
    const fixedRatePlanMinValue = '$1,000';
    this.plans = {

        FixedRatePlan: {
            Dental: {
                planTerm: '24, 36, 48, 60, 72, or 84 months',
                caseSize: ['$16,000 to $50,000', '$8,000 to $15,999', `${fixedRatePlanMinValue} to $7,999`],
                practiceFee: ['3.99%', '4.99%', '5.99%']
            },

            'Hair Restoration': {
                planTerm: '24, 36, 48, 60, 72, or 84 months',
                caseSize: ['$16,000 to $50,000', '$8,000 to $15,999', `${fixedRatePlanMinValue} to $7,999`],
                practiceFee: ['3.99%', '4.99%', '5.99%']
            },

            Bariatric: {
                planTerm: '24, 36, 48, 60, 72, or 84 months',
                practiceFee: ['4.9%']
            },

            Fertility: {
                planTerm: '24, 36, 48, 60, 72, or 84 months',
                practiceFee: ['5.9%']
            }
        },

        PromotionalRatePlan: {
            Dental: {
                planTerm: '24, 36, 48 or 60 months',
                caseSize: ['$16,000 to $32,000', '$8,000 to $15,999', '$1,000 to $7,999'],
                practiceFee: ['3.99%', '4.99%', '5.99%']
            },

            'Hair Restoration': {
                planTerm: '24, 36, 48 or 60 months',
                caseSize: ['$16,000 to $32,000', '$8,000 to $15,999', '$1,000 to $7,999'],
                practiceFee: ['3.99%', '4.99%', '5.99%']
            },

            Bariatric: {
                planTerm: '24, 36, 48 or 60 months',
                practiceFee: ['4.9%']
            },

            Fertility: {
                planTerm: '24, 36, 48 or 60 months',
                practiceFee: ['5.9%']
            }
        }
    };
  }

  render() {
    const { practiceType, fixedRatePlan } = this.props;

      const planType = fixedRatePlan ? 'FixedRatePlan' : 'PromotionalRatePlan';
      const practiceInfo = this.plans[planType][practiceType];
      const gridClassName = practiceInfo.practiceFee.length > 1 ? 'non-pni-grid' : 'non-pni-grid single-row';
      const tableHeader = practiceInfo.caseSize ? (<tr className='header-row'>
          <th><b>Plan Term</b></th>
          <th><b>Case Size</b></th>
          <th><b>Practice Fee</b></th>
      </tr>) :
          (<tr className='header-row'><th><b>Plan Term</b></th><th><b>Practice Fee</b></th></tr>);
      const planTermCol = <tr>
          <td rowSpan={practiceInfo.practiceFee.length + 1} className='multi-row'>{ practiceInfo.planTerm }</td>
      </tr>;

      const planInfoRows = practiceInfo.practiceFee.map((val, ind) => {
          const caseSizeCol = practiceInfo.caseSize ? <td>{practiceInfo.caseSize[ind]}</td> : '';
          const practiceFeeCol = practiceInfo.practiceFee ? <td>{val}</td> : '';
          return (
              <tr key={`plan_${ind}`}>
                  {caseSizeCol}
                  {practiceFeeCol}
              </tr>
          );
      });

      return <table className={gridClassName}>
          <tbody>
          {tableHeader}
          {planTermCol}
          {planInfoRows}
          </tbody>
      </table>;
  }
}

export default NonPNIGrid;

